import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';
import React, { ChangeEvent } from 'react';
import Utilities from '@util/Utilities';
import { ErrorMessage } from '@hookform/error-message';
import _isEmpty from 'lodash/isEmpty';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';

const AlertFilterRoomTypesField: React.FunctionComponent<{
	form: any,
	companyHotel: CompanyHotel
}> = ({ form, companyHotel }) => {


	const roomTypes = companyHotel.roomMappingTypeConfigurations.filter(rt => rt.isEnabled && rt.type !== HotelRoomMappingType.NONE);

	const roomTypesWatch: HotelRoomMappingType[] = form.watch('filter.roomTypes');

	const contains = (type: HotelRoomMappingType) => {
		return !_isEmpty(roomTypesWatch) && roomTypesWatch.includes(type);
	};

	const selectedIndexes = roomTypes
		.map((rt, i) => (contains(rt.type) ? i : -1))
		.filter(i => i !== -1);
	const minSelected = selectedIndexes.length ? Math.min(...selectedIndexes) : -1;
	const maxSelected = selectedIndexes.length ? Math.max(...selectedIndexes) : -1;

	const isEnabled = (index: number) => {
		if (selectedIndexes.length === 0) return true;
		if (index >= minSelected && index <= maxSelected) return true;
		return index === maxSelected + 1;
	};

	const onChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
		if (e.target.checked) {
			if (selectedIndexes.length === 0) {
				form.setValue('filter.roomTypes', [roomTypes[index].type], { shouldValidate: true, shouldDirty: true });
			} else if (index === maxSelected + 1) {
				const next = roomTypes.slice(minSelected, index + 1).map(rt => rt.type);
				form.setValue('filter.roomTypes', next, { shouldValidate: true, shouldDirty: true });
			}
		} else {
			const next = roomTypes.slice(minSelected, index).map(rt => rt.type);
			form.setValue('filter.roomTypes', next, { shouldValidate: true, shouldDirty: true });
		}
	};

	return <>

		<p className="text-sm font-semibold leading-6 text-gray-900 mb-2">Room Types</p>
		<div className="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-1 flex-wrap">
			{roomTypes.map((rt, index) => {
				const disabled = !isEnabled(index);
				return <div key={rt.type} className="flex items-center">
					<input
						id={`input_${rt.type}`}
						type="checkbox"
						value={rt.type}
						onChange={(e) => onChange(e, index)}
						checked={contains(rt.type)}
						disabled={disabled}
						className={`input-checkbox ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
					/>
					<label
						htmlFor={`input_${rt.type}`}
						className={`ml-2 label ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
					>
						{Utilities.snakeCaseToWords(rt.name)}
					</label>
				</div>;
			})}

		</div>
		<ErrorMessage
			errors={form.formState.errors}
			name="filter.roomTypes"
			render={({ message }) => <p className="help help-error">{message}</p>}
		/>
	</>;

};

export default AlertFilterRoomTypesField;